export default __webpack_public_path__ + "static/media/Friends1.a5d87502.jpeg";